export default "__VITE_ASSET__Dn00BNid__"